










import Vue from "vue";
import SearchBar from "@/components/layout/SearchBar.vue";
import Meldungen from "@/components/sections/Meldungen.vue";
import { FilterParameter } from "@/types/FilterParameter";

export default Vue.extend({
  name: "Home",
  components: {
    Meldungen,
    SearchBar,
  },
  data: function () {
    return {
      filter: {
        query: "",
        type: "",
        sender: "",
      } as FilterParameter,
    };
  },
  methods: {
    onSearchChange(filter: FilterParameter) {
      this.filter = filter;
    },
  },
});
